import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/tripLog/mapView',
    name: 'tripLogMap',
    meta: {
      title: '骑行日志',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/tripLog/map/index.vue'),
  },
  {
    path: '/tripLog/tracks',
    name: 'tripLogMapTracks',
    meta: {
      title: '骑行日志',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/tripLog/map/tracks.vue'),
  },
  {
    // path: '/tripLog/history',
    path: '/tripLog/map',  //入口由地图页更换为日志页 为了方便客户端不动，H5改更路由
    name: 'tripLogHistory',
    meta: {
      title: '骑行日志',
      isApp: true,
      auth: false,
      keepAlive: true,
    },
    component: () => import('@/views/tripLog/history/index.vue'),
  },
  {
    path: '/tripLog/score',
    name: 'tripLogScore',
    meta: {
      title: '驾驶评分',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/tripLog/score/index.vue'),
  },
]

export default routes
